<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#0965dc">
      <v-icon>
        mdi-cube-outline
      </v-icon>
      Edit Parent Org Unit
    </SecondaryButton>
    <EditParentDialog
      :unit="unit"
      :parent="parent"
      v-if="open"
      :open="open"
      @close="open = false"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import EditParentDialog from "@/views/settings/Organisation/Units/dialogs/EditParentDialog";

export default {
  props: {
    unit: {
      type: Object,
      require: true
    },
    parent: Object
  },
  components: {
    BaseAction,
    SecondaryButton,
    EditParentDialog
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    openDialog() {
      this.open = true;
    },
    closeDialog() {
      this.open = false;
    }
  }
};
</script>
